<template>
    <HeaderContent title="Accomodation" />
    <ActionContent
        ctaText="Accomodation"
        :filterDate="false"
        :filterModal="false"
        @action="createModal"
        @search-query="searchData"
    />
    <AccommodationForm
        :modal="modal"
        :selectedData="selectedData"
        @update:modal="updateModal"
        @addOrUpdate="getAll"
    ></AccommodationForm>

    <DataTable
        :data="accomodationList"
        :header="headers"
        :custom-actions="customActions"
    >
    </DataTable>
</template>

<script setup>
import axios from "axios";
import HeaderContent from "@/components/HeaderContent.vue";
import ActionContent from "@/components/ActionContent.vue";
import AccommodationForm from "./AccommodationForm.vue";
import DataTable from "@/components/DataTable.vue";
import { ref, onMounted, inject } from "vue";
import { useLoading } from "vue-loading-overlay";
import { useAuthStore } from "@/store/auth.js";
import { useToast } from "vue-toastification";
import { formatRupiah } from "@/utils/format";

const auth = useAuthStore();
const $loading = useLoading();
const selectedData = ref({});
const modal = ref(false);
const swal = inject("$swal");
const toast = useToast();

const headers = ref([
    {
        key: "no",
        label: "No",
        thClass: "text-center px-1",
        tdClass: "text-center px-1",
    },
    {
        key: "destination_format",
        label: "Destination",
        sortable: true,
        thClass: "text-left",
        tdClass: "text-left",
    },
    {
        key: "code",
        label: "Hotel Code",
        sortable: true,
        thClass: "text-left",
        tdClass: "text-left",
    },
    {
        key: "name",
        label: "Hotel Name",
        sortable: true,
        thClass: "text-left",
        tdClass: "text-left",
    },
    {
        key: "room_type",
        label: "Room Type",
        sortable: true,
        thClass: "text-left",
        tdClass: "text-left",
    },
    {
        key: "pax",
        label: "Pax",
        sortable: true,
        thClass: "text-center",
        tdClass: "text-center",
    },
    {
        key: "price",
        label: "Price",
        sortable: true,
        thClass: "text-right",
        tdClass: "text-right",
        formatter: (value) => formatRupiah(value),
    },
    {
        key: "sub_total",
        label: "Subtotal",
        sortable: true,
        thClass: "text-right",
        tdClass: "text-right",
        formatter: (value) => formatRupiah(value),
    },
    {
        key: "status_extra_bed",
        label: "Extra Bed",
        sortable: true,
        thClass: "text-right",
        tdClass: "text-right",
    },
    {
        key: "extra_bed_price",
        label: "Extra Bed Price",
        sortable: true,
        thClass: "text-right",
        tdClass: "text-right",
        formatter: (value) => formatRupiah(value),
    },
    
    {
        key: "total_price",
        label: "Total Price",
        sortable: true,
        thClass: "text-right",
        tdClass: "text-right",
        formatter: (value) => formatRupiah(value),
    },
        
    { key: "action", label: "Action" },
]);
const customActions = ref([
    {
        label: "Edit",
        variant: "success",
        icon: "fas fa-edit",
        action: (item) => {
            selectedData.value = item;
            modal.value = true;
            // getByUuid(item.uuid);
        },
    },
    {
        label: "Delete",
        variant: "danger",
        icon: "fas fa-trash",
        action: (item) => {
            swal({
                title: "Confirm",
                text: "Are you sure to delete this data?",
                showCancelButton: true,
                confirmButtonText: "Yes, delete!",
                cancelButtonText: "Cancel",
                customClass: {
                    popup: "rounded",
                    confirmButton: "btn btn-danger me-2",
                    cancelButton: "btn btn-secondary",
                },
                buttonsStyling: false,
            }).then((confirm) => {
                if (confirm.value) {
                    deleteData(item.uuid);
                } else {
                    swal.close();
                }
            });
        },
    },
]);

const searchData = async (search) => {
    const loader = $loading.show({
        color: "#489464",
        loader: "spinner",
    });
    try {
        await getAll(search);
    } finally {
        loader.hide();
    }
};

const createModal = () => {
    selectedData.value = {};
    modal.value = true;
};

const updateModal = (newValue) => {
    modal.value = newValue;
};

let accomodationList = ref([]);

const getAll = async (search = "") => {
    const response = await axios.get(
        `${process.env.VUE_APP_API_URL}/accomodation`,
        {
            params: {
                search: search,
            },
            headers: {
                "Content-type": "application/json",
                Authorization: "Bearer " + auth._token,
            },
        }
    );

    const res = response.data;

    if (res.status) {
        accomodationList.value = res.data.map((i) => ({
            ...i,
            destination_format: `${i.destination.name} (${i.destination.code})`,
            price_format: formatRupiah(i.price),
            sub_total_format: formatRupiah(i.sub_total),
            status_extra_bed: i.extra_bed,
        }));
    }
};

// const getByUuid = async (uuid) => {
//     if (uuid) {
//         toast.clear();
//         const loader = $loading.show({
//             color: "#009689",
//             loader: "bars",
//             zIndex: 999999,
//         });

//         try {
//             const response = await axios.get(
//                 `${process.env.VUE_APP_API_URL}/route/detail/${uuid}`,
//                 {
//                     headers: {
//                         "Content-type": "application/json",
//                         Authorization: "Bearer " + auth._token,
//                     },
//                 }
//             );

//             const res = response.data;

//             if (res.status) {
//                 selectedData.value = res.data;
//                 modal.value = true;
//             }
//         } finally {
//             loader.hide();
//         }
//     }
// };

const deleteData = async (uuid) => {
    if (uuid) {
        toast.clear();
        const loader = $loading.show({
            color: "#009689",
            loader: "bars",
            zIndex: 999999,
        });

        try {
            const response = await axios.delete(
                `${process.env.VUE_APP_API_URL}/accomodation/delete/${uuid}`,
                {
                    headers: {
                        "Content-type": "application/json",
                        Authorization: "Bearer " + auth._token,
                    },
                }
            );

            const res = response.data;

            if (res.status) {
                toast.success(res.message);
                getAll();
            }
        } finally {
            loader.hide();
        }
    }
};

onMounted(async () => {
    const loader = $loading.show({
        color: "#489464",
        loader: "spinner",
    });
    try {
        await getAll();
    } finally {
        loader.hide();
    }
});
</script>
